const enumErrorType = {
  Unknow: "未知",
  VoiceLogicError: "用户使用了不合理的参数或者调用逻辑",
  VoiceTokenError: "用户使用了不合理的参数或者调用逻辑。通用客户端错误码，通常是涉及Token相关的不正确使用，例如Token过期或者非法",
  VoiceInvalidError: "无效或者错误的报文消息",
  VoiceParameterError: "用户传递的参数有误，一般常见于RESTful接口调用",
  VoiceExcessiveConcurrentRequests: "并发请求过多",
  VoiceMessageHeaderErrorOrFormatIsIllegal: "错误的消息头或传输的语音WAV头不合法",
  VoiceTheprobationaryPeriodHasEndedOrAccountArrears: "试用期已结束，并且未开通商用版、或账号欠费",
  VoiceUnsupportedInterfaceOrparameter: "不支持的接口或参数",
  NoValidTextHasBeenSet: "没有设置有效的待合成文本文字|客户端侧通用错误码",
  VoiceClientActiveTerminationsBeforeRequestProcessingIsCompleted: "在请求处理完成前客户端主动结束",
  VoiceUnsupportedMessageDirective: "客户端发送了当前不支持的消息指令",
  VoiceAppkeyDoesNotExist: "使用了不存在的Appkey",
  VoiceAppkeyandTokenDoNotMatch: "调用时传递的Appkey和Token并非同一个账号UID所创建，导致不匹配",
  VoiceTokenNotPresentOrExpired: "使用的Token无效，例如Token不存在或者已过期",
  VoiceUnableToObtainRouteForAppkey: "无法获取该Appkey的路由信息",
  VoiceUnsupportedSamplingRateFormat: "不支持的采样率格式",
  VoiceFailedObtainDataTimeout: "获取客户端发送的数据超时失败",
  VoiceMachineLoadOrNetworkOrOtherFactorsAbnormal: "受机器负载、网络等因素导致的异常，通常为偶发出现",
  VoiceUnsupportedAudioFormat: "不支持的音频格式",
  VoiceInvalidAudio: "无效的音频",
  FailedToDetectAudioFileInformation: "检测音频文件信息失败",
  VoiceInvalidAudioStream: "无有效音频流",
  VoiceFileDownloadFailed: "文件下载失败",
  NoDataSentForLongTime: "请求建立链接后，长时间没有发送任何数据，超过10s后服务端会返回此错误信息",
  VoiceSynthesisCallClientError: "语音合成调用客户端错误。(可能有多个错误消息，需根据对应的错误消息调整)",
  AbnormalitiesCausedByMachineLoadOrNetworkFactors: "受机器负载或网络等因素导致的异常，通常为偶发出现",
  RecordingFileRecognitionTaskRunning: "录音文件识别任务运行中",
  RecordingFileRecognitionTaskQueued: "录音文件识别任务排队中",
  NotValidSpeechWasRecognized: "识别结果查询接口调用成功，但是没有识别到有效语音",
  SingleDayTimeLimitExceeded: "单日时间超限",
  FileDownloadFailed: "文件下载失败",
  FileFormatError: "文件格式错误",
  FileTooLarge: "文件过大",
  FileNormalizationFailed: "文件归一化失败",
  FileParsingFailed: "文件解析失败",
  MKVParsingFailed: "MKV解析失败",
  SamplingRateMismatch: "采样率不匹配",
  RecordingFileRecognitionTaskExpired: "录音文件识别任务过期",
  RequestFile_IllegalLinkParameter: "请求file_link参数非法",
  RequestCallback_UrlParameter: "请求callback_url参数非法",
  InvalidRequestParameters: "请求参数无效",
  RequestParameterAppkeyValueEmpty: "请求参数appkey值为空",
  RequestParameterAppkeyNotRegistered: "请求参数appkey未注册",
  RAMCheckFailed: "RAM检查失败",
  ContentLength_CheckFailed: "content-length 检查失败",
  FileNeedsDownloadedDoesNotExist: "需要下载的文件不存在",
  NoPermissionToDownload: "没有权限下载需要的文件",
  ServiceTheRequestFileLocatedIsNotAvailable: "请求文件所在的服务不可用",
  Audio16kNeedsToBeWhitelistedBeforeItCanBeUsed: "16k音频需要加白名单后才可使用",
  NoValidTextWasRecognized: "未识别出有效文字",
  DownloadTimeout: "文件下载超时或失败",
  UnableToExtractAudioTrackFile: "无法提取音轨文件",
  FailedToUploadTemporaryOSS: "未能将音频上传至临时OSS存储区",
  AbnormalWhileExtractingAudio: "下载文件，提取音轨时异常",
  NullReferenceException: "对象引用未设置为对象的实例",
  JsonException: "JSON值转换错误",
  UrlIsIllegal: "Url不合法，请检查url能否正常打开",
  ImageFormatNotSupported: "暂不支持图片格式",
  FileDownloadTimeout: "文件下载超时或失败",
  AggregateException: "出现一个或多个错误|请求的名称有效，但是找不到请求的类型的数据",
};

export default enumErrorType;
